import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IQuoteTemplateState } from './quotetemplate.types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IQuoteTemplateState = {
  version: 1,
  serviceTemplates: [],
  freightTemplates: [],
  paymentTermTemplates: [],
  termTemplates: []
};

const namespaced = true;

export const quoteTemplate: Module<IQuoteTemplateState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
